import React, { act, useEffect, useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { v4 as uuidv4 } from "uuid";

import {
  faCalendarAlt,
  faSave,
  faTrash,
  faPlus,
  faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";
import * as moment from "moment";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { insertarCuotaFraccionada } from "../../../../actions/pagosActions";
import { updateStateModalBasic } from "../../../../actions/modalActions";
import { avisoError } from "../../AvisosMensajes/MensajesSwalf";

const FormularioCuotas = (props) => {
  const cuotasActuales = useSelector(
    (state) => state.pagos.datosFinanzasDiscente.cuotasPensiones.todo.cuotas
  );

    const fecha_matricula = useSelector(state => state.pagos.datosFinanzasDiscente.matriculaActiva.fecha_matricula);

  const { monto_total } = props;

  const params = new URLSearchParams(window.location.search);
  const idPension = params.get("pension");
  const dispatch = useDispatch();
  // Estado para los valores de cada cuota
  const [cuotas, setCuotas] = useState([
     {id_dt_matricula: idPension, id: uuidv4(), monto_establecido: "", fecha_limite: "", actual: false }
  ]);

  const cargarCuotasActuales = () => {
    if (cuotasActuales.length === 0) return;
    // Si ya hay cuotas actuales, las cargamos en el estado
    setCuotas(
      cuotasActuales.map(
        ({ id, monto_establecido, fecha_limite, id_tp_estado_pago }) => ({
          id_dt_matricula: idPension,
          id_cuota: id,
          id: uuidv4(),
          monto_establecido,
          fecha_limite,
          pagada: id_tp_estado_pago == 1, // true solo si es 1, false en cualquier otro caso
          eliminado: false, // Nueva propiedad para marcar si la cuota fue eliminada
          actual: true,
        })
      )
    );
  };

  // Maneja el cambio de los campos de cada cuota
  const handleCuotaChange = (id, field, value) => {
    setCuotas((prev) =>
      prev.map((c) => (c.id === id ? { ...c, [field]: value } : c))
    );
  };

  // Agrega una nueva cuota vacía
  const handleAgregarCuota = () => {
    if (
      cuotas.filter((c) => !c.eliminado || c.eliminado === undefined).length >=
      3
    ) {
      avisoError("Solo se permiten 3 cuotas fraccionadas.");
      return; // Límite de 3 cuotas
    }
    setCuotas([
      ...cuotas,
      {id_dt_matricula: idPension, id: uuidv4(), monto_establecido: "", fecha_limite: "", actual: false },
    ]);
  };

  const handleEliminarCuota = (id) => {
    if ( cuotas.filter((c) => !c.eliminado || c.eliminado === undefined).length == 1) {
      avisoError("Debe haber al menos una cuota.");
      return;
    }

    const cuota = cuotas.find((c) => c.id === id);

    if (cuota.actual) {
      // Si la cuota es actual, solo la marcamos como eliminada
      const nuevasCuotas = cuotas.map((c) =>
        c.id === id ? { ...c, eliminado: true } : c
      );
      setCuotas(nuevasCuotas);
    } else {
      // Si no es actual, la eliminamos del array
      const nuevasCuotas = cuotas.filter((c) => c.id !== id);
      setCuotas(nuevasCuotas);
    }
  };

  // Validación simple para cada cuota
  const validarCuotas = () => {
    // Primero validamos cada cuota individual

   if (cuotas.filter((c) => !c.eliminado || c.eliminado === undefined).length == 1) {
      avisoError("Debe haber mas de una cuota.");
      return false;
    }

    const cuotasValidas = cuotas.every(
      (c) =>
        c.monto_establecido &&
        !isNaN(Number(c.monto_establecido)) &&
        Number(c.monto_establecido) > 0 &&
        c.fecha_limite
    );

 

    if (!cuotasValidas) {
      avisoError(
        "Por favor, complete correctamente todos los campos de las cuotas."
      );
      return false;
    }

    // Luego validamos el total de las cuotas
    const total = cuotas
      .filter((c) => !c.eliminado) // solo cuotas activas
      .reduce((acc, c) => acc + Number(c.monto_establecido || 0), 0);

    if (total !== Number(monto_total)) {
      avisoError(
        "El total de las cuotas no puede ser mayor o menor al monto total de la cuota original."
      );
      return false;
    }

    return true;
  };

  // Enviar todas las cuotas
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validarCuotas()) {
      const cuotasEnviadas = cuotas.filter((cuota) => !cuota.pagada || cuota.pagada === undefined) // solo no pagadas
      dispatch(insertarCuotaFraccionada(cuotasEnviadas));
      dispatch(updateStateModalBasic());
    }
  };

  const handleModal = () => {
    dispatch(updateStateModalBasic());
  };

  useEffect(() => {
    cargarCuotasActuales();
  }, []);

  return (
    <div className="FormularioCuotas p-3">
      <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
        <h4 className="mb-0 ml-2">Cuotas fraccionadas</h4>
        <Button
          variant="success"
          onClick={handleAgregarCuota}
          disabled={
            cuotas.filter((c) => !c.eliminado || c.eliminado === undefined)
              .length >= 3
          }
          title="Agregar cuota fraccionada"
          className="mr-2"
        >
          <FontAwesomeIcon icon={faPlus} className="mr-1" />
          Agregar cuota
        </Button>
      </div>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {cuotas
            .filter((c) => !(c.actual && c.eliminado)) // no mostrar cuotas actuales eliminadas
            .map((cuota, idx) => (
              <div
                key={cuota.id}
                className={`mb-4 p-3 rounded shadow-sm border position-relative bg-white ${
                  cuota.pagada ? "border-success" : "border-info"
                }`}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="font-weight-bold text-primary">
                    Cuota #{idx + 1}
                  </span>
                  <div>
                    {cuota.pagada && (
                      <span className="badge badge-success mr-2">Pagada</span>
                    )}
                    {cuotas.length > 1 && !cuota.pagada && (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleEliminarCuota(cuota.id)}
                        title="Eliminar cuota"
                      >
                        <FontAwesomeIcon icon={faMinusCircle} />
                      </Button>
                    )}
                  </div>
                </div>
                <Form.Row>
                  <Form.Group className="col-md-6">
                    <Form.Label htmlFor={`monto_establecido_${idx}`}>
                      Monto <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text>S/.</InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        id={`monto_establecido_${idx}`}
                        name={`monto_establecido_${idx}`}
                        value={cuota.monto_establecido}
                        disabled={cuota.pagada}
                        onChange={(e) =>
                          handleCuotaChange(
                            cuota.id,
                            "monto_establecido",
                            e.target.value
                          )
                        }
                        isInvalid={
                          cuota.monto_establecido !== "" &&
                          (isNaN(Number(cuota.monto_establecido)) ||
                            Number(cuota.monto_establecido) <= 0)
                        }
                        placeholder="Ingrese el monto"
                      />
                      <Form.Control.Feedback type="invalid">
                        La cantidad tiene que ser positiva.
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                  <Form.Group className="col-md-6">
                    <Form.Label htmlFor={`fecha_limite_${idx}`}>
                      Fecha límite <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faCalendarAlt} />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        type="date"
                        id={`fecha_limite_${idx}`}
                        name={`fecha_limite_${idx}`}
                        min={moment().format("YYYY-MM-DD")}
                        value={cuota.fecha_limite}
                        disabled={cuota.pagada}
                        onChange={(e) =>
                          handleCuotaChange(
                            cuota.id,
                            "fecha_limite",
                            e.target.value
                          )
                        }
                        isInvalid={cuota.fecha_limite === ""}
                      />
                      <Form.Control.Feedback type="invalid">
                        Este campo es requerido.
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Form.Row>
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between align-items-center">
          <div>
            <span className="font-weight-bold">
              Total:{" "}
              <span className="text-info">
                S/.{" "}
                {cuotas
                  .filter((c) => !c.eliminado) // solo cuotas activas
                  .reduce((acc, c) => acc + Number(c.monto_establecido || 0), 0)
                  .toFixed(2)}
              </span>
              {" / "}
              <span className="text-secondary">
                S/. {Number(monto_total).toFixed(2)}
              </span>
            </span>
          </div>
          <div>
            <Button
              variant="outline-secondary"
              type="button"
              className="mr-2"
              onClick={handleModal}
            >
              <FontAwesomeIcon icon={faTrash} className="mr-1" />
              Cancelar
            </Button>
            <Button variant="info" type="submit">
              <FontAwesomeIcon icon={faSave} className="mr-1" />
              Guardar
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    </div>
  );
};

export default FormularioCuotas;
